import { useCallback } from "react";
import useAnnotationUpdater from "./useAnnotationUpdater";
import { useAppSelector } from "../../app";
import tempAnnotationSelector from "../../annotation/selectors/tempAnnotationSelector";
import useScrollToElement from "./useScrollToElement";

const useTempAnnotationOverview = () => {
  const { removeAnnotation, removeAnnotationsInBulk, updateAnnotationsInBulk } =
    useAnnotationUpdater();

  const tempAnnotations = useAppSelector(tempAnnotationSelector);
  const { scrollToElement } = useScrollToElement();

  const scrollAnnotationIntoView = useCallback(
    (id: string) => {
      // Use unified scroll handler
      scrollToElement(`annotation-${id}`, {
        behavior: "smooth",
        block: "center",
      });
    },
    [scrollToElement],
  );

  const deleteAnnotations = useCallback(() => {
    removeAnnotationsInBulk(tempAnnotations, true);
  }, [tempAnnotations, removeAnnotationsInBulk]);

  const acceptAnnotations = useCallback(() => {
    const toUpdateAnnotations = [...tempAnnotations].map((a) => ({
      ...a,
      tempAnnotation: false,
    }));
    updateAnnotationsInBulk(toUpdateAnnotations, true);
  }, [tempAnnotations, updateAnnotationsInBulk]);

  return {
    tempAnnotations,
    scrollAnnotationIntoView,
    deleteAnnotations,
    acceptAnnotations,
    removeAnnotation,
  };
};

export default useTempAnnotationOverview;
